import { motion } from 'framer-motion';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function AnimatedStep({ children }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, x: 50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -50 }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
      className="flex-1 flex items-center justify-center p-6"
    >
      <div className="w-full max-w-md">
        {children}
      </div>
    </motion.div>
  );
}
